export async function affExternalShipmentsScanUseCase(transaction_id, identifier, externalShipmentRepository) {
    const result = await externalShipmentRepository.aff_scan_identifier(transaction_id, identifier);
    
    const entity = new externalShipmentRepository.aff_scanned_model(result.data);

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("External Shipments Aff Prepare Inválido");
    }
    
    return result;
}